export default function gePageTop (name) {
  let page = document.querySelector(name);
  if (page.scrollTop > 0) {
    page.scrollTop = 0
  }
}